import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  inputLabel: {
    fontWeight: 'bold',
    marginTop: '0.5rem',
    margin: '0.5rem 0',
    textAlign: 'left',
    fontSize: '0.875rem',
  },
  timeInputWrapper: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    fontSize: '14px',
    width: '100%',
  },
  label: {
    width: 'fit-content',
    minWidth: '100px',
  },
  timeInput: {
    width: '165px',
    '& .MuiFormHelperText-root': {
      margin: 0,
      width: 'fit-content',
      textAlign: 'right',
    },
    '&:last-child': {
      width: '80px',
    },
  },
  dueTime: {
    display: 'flex',
    flexWrap: 'wrap',
    '& p': {
      width: '100%',
    },
  },
}));

export default useStyles;
